"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoreHeatmap = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2018 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var BaseChart_1 = require("../_base/BaseChart");
var CoreHeatmap = /** @class */ (function (_super) {
    tslib_1.__extends(CoreHeatmap, _super);
    function CoreHeatmap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CoreHeatmap.prototype.render = function () {
        return react_1.default.createElement(BaseChart_1.BaseChart, tslib_1.__assign({ type: "heatmap" }, this.props));
    };
    return CoreHeatmap;
}(react_1.default.PureComponent));
exports.CoreHeatmap = CoreHeatmap;
//# sourceMappingURL=CoreHeatmap.js.map